import ReactDOM from "react-dom";

const CommonModal = ({
  isOpen,
  onClose,
  title = "Change Source",
  children,
  alertIcon,
  alertType,
  showAlert = true,
}) => {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div
      style={{
        position: "fixed",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          zIndex: 99999,
          borderRadius: "0.375rem",
          boxShadow:
            "0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -4px rgba(0,0,0,0.1)",
          width: "100%",
          maxWidth: "36rem",
          position: "relative",
          paddingLeft: "1.5rem",
          paddingRight: "1.5rem",
          paddingBottom: "1.5rem",
        }}
      >
        <div style={{ paddingTop: "1.5rem" }}>
          <h2
            style={{
              fontSize: "1.125rem",
              lineHeight: "1.75rem",
              fontWeight: 500,
              color: "rgb(17, 24, 39)",
              marginTop: "1rem",
              marginBottom: "1rem",
            }}
          >
            {title}
          </h2>
        </div>

        {children}

        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: "0.75rem",
            right: "1rem",
            color: "rgb(107, 114, 128)",
            fontSize: "1.875rem",
            lineHeight: "2.25rem",
            fontWeight: 600,
            cursor: "pointer", // added for usability
          }}
          // NOTE: inline styles can’t do hover effects. Use JS or CSS instead.
        >
          &times;
        </button>
      </div>
    </div>,
    document.body
  );
};

export default CommonModal;
